export interface PasswordValidationResult {
  isValid: boolean;
  error?: string;
}

export const validatePassword = (
  password: string,
): PasswordValidationResult => {
  if (!password) {
    return {
      isValid: false,
      error: 'Password is required',
    };
  }

  if (password.length < 6) {
    return {
      isValid: false,
      error: 'Password must be at least 6 characters long',
    };
  }

  return { isValid: true };
};

export const validatePasswordMatch = (
  password: string,
  confirmPassword: string,
): PasswordValidationResult => {
  if (password !== confirmPassword) {
    return {
      isValid: false,
      error: "Passwords don't match",
    };
  }

  return { isValid: true };
};
